import React, { useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Tabs,
  Tab
} from '@mui/material';
import {
  VideoFile as VideoFileIcon
} from '@mui/icons-material';
import TextingStoryVideoCreator from './TextingStoryVideoCreator';
import CustomMessagesPage from './CustomMessagesPage';

const MarketingTools = () => {
  const [currentTab, setCurrentTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  return (
    <Box 
      sx={{ 
        maxWidth: 1800, 
        mx: 'auto', 
        pb: 3,
        backgroundColor: '#000000'
      }}
    >
      <Card elevation={3} sx={{ backgroundColor: '#1C1C1E', color: '#FFFFFF' }}>
        <CardContent>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
            <VideoFileIcon sx={{ 
              mr: 2, 
              fontSize: { xs: 24, sm: 28, md: 32 }, 
              color: '#F53D3B' 
            }} />
            <Typography 
              variant="h4" 
              component="h1" 
              sx={{ 
                color: '#F53D3B', 
                mb: 0,
                fontSize: { xs: '1.25rem', sm: '1.75rem', md: '2.125rem' }
              }}
            >
              Smoothspeak Marketing Tools
            </Typography>
          </Box>
          
          <Box sx={{ borderBottom: 1, borderColor: '#333', mb: 2 }}>
            <Tabs 
              value={currentTab} 
              onChange={handleTabChange}
              sx={{
                '& .MuiTabs-indicator': {
                  backgroundColor: '#F53D3B',
                },
                '& .MuiTab-root': {
                  color: '#888',
                  fontSize: { xs: '0.75rem', sm: '0.875rem', md: '0.875rem' },
                  '&.Mui-selected': {
                    color: '#F53D3B',
                  },
                },
              }}
            >
              <Tab label="Video Creator" />
              <Tab label="Control App" />
            </Tabs>
          </Box>

          {currentTab === 0 && (
              <TextingStoryVideoCreator />
          )}

          {currentTab === 1 && (
              <CustomMessagesPage />
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

export default MarketingTools; 